<div class="background">
</div>
<div class="popup">
  <section class="popup__card">
    <section class="popup__images"></section>
    <section class="popup__description-box">
      <p class="popup__description-text" tabindex="0">
        {{copies.description_text_1}}<br>
        {{copies.description_text_2}}
      </p>
      <vcl-button class="popup__primary-button"
                  [label]="copies.button_know_the_offer"
                  buttonType="primary"
                  buttonStyle="light"
                  (click)="redirectToFirmlyApprovedOffer()"
                  tabindex="0"
                  role="button">
      </vcl-button>
    </section>
  </section>
  <a class="popup__secondary-button" (click)="turnOffFirmlyApprovedOffer()" tabindex="0" role="button">
    {{copies.button_not_interested}}
  </a>
</div>